import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useChatUnread } from "../../hooks/useChatUnread";

/** Chat entry point shown on Order Detail / Incoming Order Detail / Employee
 * Task Detail — opens the isolated order-chat thread with a live unread badge. */
export function ChatButton({ orderId, testid = "order-chat-btn" }) {
  const navigate = useNavigate();
  const unread = useChatUnread(orderId);
  if (!orderId) return null;
  return (
    <button
      onClick={() => navigate(`/chat/${orderId}`)}
      data-testid={testid}
      aria-label="Order chat"
      className="relative w-10 h-10 rounded-full bg-indigo-50 hover:bg-indigo-100 text-indigo-700 grid place-items-center transition"
    >
      <MessageSquare className="w-[18px] h-[18px]" strokeWidth={2.3} />
      {unread > 0 && (
        <span
          data-testid={`${testid}-badge`}
          className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center leading-none"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
}
